import { render, staticRenderFns } from "./EventStatusPill.vue?vue&type=template&id=4c115006&scoped=true"
import script from "./EventStatusPill.vue?vue&type=script&lang=js"
export * from "./EventStatusPill.vue?vue&type=script&lang=js"
import style0 from "./EventStatusPill.vue?vue&type=style&index=0&id=4c115006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c115006",
  null
  
)

export default component.exports